import React from "react";
import { useTranslation } from "react-i18next";
import "./letsStart.scss";

const LetsStart = () => {
    const {t} = useTranslation()

    return (
        <div className="container-lets-start">
            <div className="text-lets-start">
                <h1>{t("home.lets_start.title")}</h1>
                <p>{t("home.lets_start.section_text")}</p>
                <a href="/form">
                    <button id="btn-lets-start">{t("buttons.demo_btn_text")}</button>
                </a>
            </div>
        </div>
    );
}
export default LetsStart;